import axios from 'axios';
import { useTableStore } from 'components/TableWithCheck/selectTableStore';
import { HOME_SHOW_KEY_ID } from 'constants/homeApp';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { adminAPI } from 'services/admin';
import { v4 as uuidv4 } from 'uuid';
import { useNotification } from 'hooks/useNotification';

export const useFormModal = ({ data, onClose }) => {
  const [initialTitle] = useState(data.title);
  const [loading, setLoading] = useState(false);
  const { openErrorNotification } = useNotification();
  const { updateSelectedItemsByListAndId } = useTableStore();
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      ...data,
      transitionMiliseconds: data?.transitionMiliseconds || 1500,
      description: data.originalId ? data.description : data.shortDescription,
    },
    mode: 'onSubmit',
  });

  const onSubmit = async values => {
    try {
      setLoading(true);
      const { thumbImage } = values;

      const currentId = values.originalId ? values.originalId : uuidv4();

      if (thumbImage) {
        const thumbUrl = await adminAPI.post(
          `/admin/home-show/${currentId}/thumbnails`,
          {
            body: {
              parts: 1,
              mimeType: thumbImage.type,
              extension: thumbImage.name.split('.').pop(),
              fileName: thumbImage.name,
              type: 'SQUARE',
            },
          }
        );

        const signUrlUpload = thumbUrl.multipartUpload.parts[0].signedUrl;
        const uploadId = thumbUrl.multipartUpload.uploadId;
        const fileKey = thumbUrl.multipartUpload.fileKey;

        const thumbUpload = await axios.put(signUrlUpload, thumbImage, {
          headers: {
            'Content-Type': '',
          },
        });

        const eTag = thumbUpload.headers['etag'];
        await adminAPI.post('/admin/multipart-upload-complete', {
          body: {
            uploadId,
            fileKey,
            parts: [
              {
                partNumber: 1,
                eTag: eTag.replace(/"/g, ''),
              },
            ],
          },
        });

        const newThumbValue = [
          {
            type: 'SQUARE',
            distributionRegion: 'sa-east-1',
            fileKey: fileKey,
            external: false,
            url: URL.createObjectURL(thumbImage),
          },
        ];
        setValue('thumbnails', newThumbValue);
        delete values.thumbImage;
        setValue('thumbImage', undefined); // remove to prevent duplicated upload

        updateSelectedItemsByListAndId(HOME_SHOW_KEY_ID, data.id, {
          id: values.contentId || values.id, // TODO check if it works for selected videos
          originalId: currentId,
          ...values,
          thumbnails: newThumbValue,
        });
      } else {
        updateSelectedItemsByListAndId(HOME_SHOW_KEY_ID, data.id, values);
      }

      onClose();
    } catch (error) {
      openErrorNotification({
        message: 'Erro ao processar thumbnail',
      });
    } finally {
      setLoading(false);
    }
  };

  const onChangeImage = image => {
    setValue('thumbImage', image);
  };

  return {
    control,
    loading,
    initialTitle,
    onSubmit,
    onChangeImage,
    handleSubmit,
  };
};
